import { AppNS } from 'app';
import { ApiCollectionResponse } from 'app/types';

import { request } from '../config';
import { parseInspectorDisciplineDocumentsData } from '../files/parsers';

const INSPECTOR_DISCIPLINES = 'inspector-disciplines';
const DOCUMENTS = 'documents';

export function apiGetInspectorDisciplines(
  data: AppNS.Params,
  signal?: AbortSignal,
): Promise<AppNS.InspectorDiscipline[]> {
  return request(
    {
      url: `${INSPECTOR_DISCIPLINES}.json`,
      method: 'GET',
      params: { limit: 1000, with_documents: true, archived_at_exists: false, ...data },
      signal,
    },
    (data) => {
      return data.models.results.map((item: AppNS.Params) => {
        return { ...item, documents: parseInspectorDisciplineDocumentsData(item.documents) };
      });
    },
  );
}

export function apiGetInspectorDisciplineById(
  id: string,
  params: AppNS.Params = {},
  signal?: AbortSignal,
): Promise<AppNS.InspectorDiscipline> {
  return request(
    {
      url: `${INSPECTOR_DISCIPLINES}/${id}.json`,
      method: 'GET',
      params: { with_documents: true, ...params },
    },
    (data) => {
      return { ...data.model, documents: parseInspectorDisciplineDocumentsData(data.model.documents) };
    },
  );
}

export function apiSetDiscipline(data: Partial<AppNS.InspectorDiscipline>): Promise<AppNS.InspectorDiscipline> {
  if (data?.id) {
    return apiUpdateDiscipline(data?.id, data);
  }
  return apiAddDiscipline(data);
}

export function apiAddDiscipline(data: Partial<AppNS.InspectorDiscipline>): Promise<AppNS.InspectorDiscipline> {
  return request(
    {
      url: `${INSPECTOR_DISCIPLINES}.json`,
      method: 'POST',
      data: {
        inspector_discipline: {
          ...data,
        },
      },
    },
    (data) => {
      return { ...data.model, documents: parseInspectorDisciplineDocumentsData(data.model.documents) };
    },
  );
}

export function apiUpdateDiscipline(
  disciplineId: string,
  data: Partial<AppNS.InspectorDiscipline>,
): Promise<AppNS.InspectorDiscipline> {
  return request(
    {
      url: `${INSPECTOR_DISCIPLINES}/${disciplineId}.json`,
      method: 'PATCH',
      data: {
        inspector_discipline: {
          ...data,
        },
      },
    },
    (data) => {
      return { ...data.model, documents: parseInspectorDisciplineDocumentsData(data.model.documents) };
    },
  );
}

export function apiRemoveDiscipline(id: string): Promise<AppNS.Company> {
  return request(
    {
      url: `${INSPECTOR_DISCIPLINES}/${id}`,
      method: 'DELETE',
    },
    (data) => {
      return data.model;
    },
  );
}

export function apiGetDisciplineDocuments(
  opts: AppNS.Params = {},
  signal?: AbortSignal,
): Promise<ApiCollectionResponse<AppNS.InspectorDisciplineDocument>> {
  return request(
    {
      url: DOCUMENTS,
      method: 'GET',
      params: {
        object_type: 'v2/inspector_discipline',
        object_id: opts.object_id,
        limit: 20,
        ...opts,
      },
      signal,
    },
    (data) => {
      return { ...data.models, results: parseInspectorDisciplineDocumentsData(data.models.results) };
    },
  );
}

export function apiDeactivateDiscipline(disciplineId: string): Promise<AppNS.InspectorDiscipline> {
  return request(
    {
      url: `${INSPECTOR_DISCIPLINES}/${disciplineId}/deactivate.json`,
      method: 'PATCH',
    },
    (data) => {
      return { ...data.model };
    },
  );
}

export function apiReactivateDiscipline(disciplineId: string): Promise<AppNS.InspectorDiscipline> {
  return request(
    {
      url: `${INSPECTOR_DISCIPLINES}/${disciplineId}/reactivate.json`,
      method: 'PATCH',
      data: {
        inspector_discipline: {
          state: 'approved',
        },
      },
    },
    (data) => {
      return { ...data.model };
    },
  );
}
